// Monthly value type for emission control data
export interface MonthlyValue {
  value: number;
}

// Type for all 12 months with consistent structure
export type MonthlyEmissionControl = Record<
  "jan" | "feb" | "mar" | "apr" | "may" | "jun" | "jul" | "aug" | "sep" | "oct" | "nov" | "dec",
  MonthlyValue
>;

// Emission control detail with improved naming and optional monthly data
export interface EmissionControlDetail {
  emissionControlId: string;
  efficiency: number;
  portion: number | null;
  monthlyData?: MonthlyEmissionControl;
  unit?: string;
}

export interface Tank {
  no?: string;
  _id?: string;
  year: number | null;
  companyId: string | null;
  tankId: string;
  area: string;
  chemicalName: string;
  tankTypeId: string;
  tankType: string;
  emissionControlId: string;
  emissionControl: string;
  efficiency: number;
  controlExceptionDate: ControlException[];
  arrControlExceptionDate: string[];
  emission: Emission;
  isWarning?: boolean;
  isFlowActive?: boolean;
  emissionControlDetails?: EmissionControlDetail[];
}

export interface ControlException {
  startDate: string;
  endDate: string;
}

export interface Emission {
  tvoc: boolean;
  bz: boolean;
  bd: boolean;
  vcm: boolean;
  edc: boolean;
}

export const initialInform: Tank = {
  _id: "",
  year: null,
  companyId: null,
  tankId: "",
  area: "",
  chemicalName: "",
  tankTypeId: "",
  emissionControlId: "",
  controlExceptionDate: [],
  arrControlExceptionDate: [],
  emission: {
    tvoc: true,
    bz: false,
    bd: false,
    vcm: false,
    edc: false,
  },
  tankType: "",
  emissionControl: "",
  efficiency: 0,
  emissionControlDetails: [
    {
      emissionControlId: "",
      efficiency: 0,
      portion: null,
    },
  ],
};

export interface OptionFilter {
  key: string;
  filter: [];
}

export interface Filter {
  text: string;
  value: string;
}

export interface OptionMaster {
  label: string;
  value: string;
  _id: string;
}

export interface Dropdown {
  key?: string;
  label: string;
  value: string | number;
}

export interface RowData {
  index?: number;
  _id?: string;
  no?: string | number | "";
  tankId?: string | "";
  area?: string;
  chemicalName?: string | "";
  tankTypeId?: string;
  tankType?: string;
  emissionControlId?: string;
  emissionControl?: string;
  efficiency?: string;
  key?: string;
  parameter?: string;
  type?: "emission" | "emissionControl";
  unit: string;
  jan: number;
  feb: number;
  mar: number;
  apr: number;
  may: number;
  jun: number;
  jul: number;
  aug: number;
  sep: number;
  oct: number;
  nov: number;
  dec: number;
  total: number;
}

export type DataTable = RowData[];

export interface Measurement {
  value: number | null;
  unit: string;
}

export interface TankEmission {
  tvoc?: Measurement;
  bz?: Measurement;
  bd?: Measurement;
  vcm?: Measurement;
  edc?: Measurement;
}

export interface PropertyMonthly {
  emission: TankEmission;
  reportStatus: string;
}

export interface Month {
  title: string;
  dataIndex: keyof ManualEmissionTank;
}

export interface ManualEmissionTank {
  jan: PropertyMonthly;
  feb: PropertyMonthly;
  mar: PropertyMonthly;
  apr: PropertyMonthly;
  may: PropertyMonthly;
  jun: PropertyMonthly;
  jul: PropertyMonthly;
  aug: PropertyMonthly;
  sep: PropertyMonthly;
  oct: PropertyMonthly;
  nov: PropertyMonthly;
  dec: PropertyMonthly;
}

export interface TankManual {
  _id?: string;
  year: number | null;
  companyId: string | null;
  tankId: string;
  area: string;
  chemicalName: string;
  tankTypeId: string;
  tankType: string;
  emissionControlId: string;
  emissionControl: string;
  efficiency: string;
  emission: Emission;
  manualEmissionTank: ManualEmissionTank;
  emissionControlDetails: EmissionControlDetail[];
}

export const MONTH_MAP: Month[] = [
  { title: "Jan", dataIndex: "jan" },
  { title: "Feb", dataIndex: "feb" },
  { title: "Mar", dataIndex: "mar" },
  { title: "Apr", dataIndex: "apr" },
  { title: "May", dataIndex: "may" },
  { title: "Jun", dataIndex: "jun" },
  { title: "Jul", dataIndex: "jul" },
  { title: "Aug", dataIndex: "aug" },
  { title: "Sep", dataIndex: "sep" },
  { title: "Oct", dataIndex: "oct" },
  { title: "Nov", dataIndex: "nov" },
  { title: "Dec", dataIndex: "dec" },
];

export interface TankVocEmission {
  no?: string;
  _id?: string;
  year: number | null;
  companyId: string | null;
  tankId: string;
  area: string;
  chemicalName: string;
  tankTypeId: string;
  tankType: string;
  jan: Number;
  feb: Number;
  mar: Number;
  apr: Number;
  may: Number;
  jun: Number;
  jul: Number;
  aug: Number;
  sep: Number;
  oct: Number;
  nov: Number;
  dec: Number;
}

export interface SummaryVocEmission {
  key: string;
  label: string;
  emission: string;
  jan: number;
  feb: number;
  mar: number;
  apr: number;
  may: number;
  jun: number;
  jul: number;
  aug: number;
  sep: number;
  oct: number;
  nov: number;
  dec: number;
  unit: string;
  total: number;
}

export interface UnitTankVoc {
  [key: string]: {
    data: TankVocEmission[];
    summary: SummaryVocEmission[];
  };
}

export interface Option {
  _id?: string;
  label: string;
  value: string;
}

export interface ResponseAPI {
  message: string;
}
